// bootstrap components
import { Row } from 'react-bootstrap'

// Emojis
import EmojiPicker from 'emoji-picker-react'

// styles
import { EmojiStyle } from 'emoji-picker-react'
import classes from './styles.module.scss'

// types
import type { EmojiClickData } from 'emoji-picker-react'
import type { FC } from 'react'

export type EmojiPickerProps = {
  onEmojiClick: (value: EmojiClickData, event: MouseEvent) => void
}

export const EmojisPicker: FC<EmojiPickerProps> = ({ onEmojiClick }) => (
  <Row className={classes.picker}>
    <EmojiPicker
      lazyLoadEmojis
      skinTonesDisabled
      emojiVersion='5.0'
      onEmojiClick={onEmojiClick}
      emojiStyle={EmojiStyle.NATIVE}
      previewConfig={{ showPreview: false }}
    />
  </Row>
)
